import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kqglKqfx",
  "use": "icon-kqglKqfx-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-kqglKqfx\"><defs><style type=\"text/css\"></style></defs><path d=\"M46.545455 919.272727h930.90909v46.545455H46.545455zM116.363636 453.818182h46.545455v349.090909H116.363636zM356.072727 81.454545h46.545455v721.454546h-46.545455zM598.109091 290.909091h46.545454v512h-46.545454zM837.818182 430.545455h46.545454v372.363636h-46.545454z\" p-id=\"17707\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol